import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageShell, PageHero } from "@/components/marketing/PageShell";
import { LucideIcon } from "@/components/marketing/LucideIcon";
import { TRUST } from "@/content/pages";

export default function Trust() {
  return (
    <PageShell testid="trust-root" seo={{
      title: "Trust & Security — Sema",
      description: TRUST.intro,
      keywords: "sema security, trust center, SOC 2, GDPR, HIPAA, data governance, encryption",
      path: "/trust",
    }}>
      <PageHero testid="trust-h1" eyebrow="Trust" accent="#3B82F6"
        title="Security you can put in front of sensitive data."
        subtitle={TRUST.intro} />

      <section className="py-8">
        <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-5 px-6 sm:grid-cols-2 lg:grid-cols-3">
          {TRUST.cards.map((c) => (
            <div key={c.title} data-testid={`trust-${c.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="rounded-2xl border border-border/60 bg-card/50 p-7 backdrop-blur">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg" style={{ backgroundColor: "#3B82F61f", color: "#3B82F6" }}>
                <LucideIcon name={c.icon} className="h-5 w-5" />
              </span>
              <h3 className="mt-4 text-base font-semibold tracking-tight">{c.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{c.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-14">
        <div className="mx-auto flex w-full max-w-4xl flex-col items-start justify-between gap-6 rounded-2xl border border-border/60 bg-card/40 p-8 backdrop-blur sm:flex-row sm:items-center">
          <div>
            <h3 className="text-lg font-semibold tracking-tight">Responsible disclosure</h3>
            <p className="mt-2 max-w-md text-sm text-muted-foreground">
              Found a vulnerability? We appreciate coordinated disclosure. Email{" "}
              <a href={`mailto:${TRUST.disclosure}`} className="text-accent hover:underline">{TRUST.disclosure}</a>.
            </p>
          </div>
          <Link to="/subprocessors">
            <Button variant="outline" className="rounded-full border-border/70 px-5 font-mono text-xs uppercase tracking-[0.2em]">
              View subprocessors <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>
      </section>
    </PageShell>
  );
}
